<mat-card>
  <app-card-header
    icono="key"
    [title]="id ? 'Editar Apikey' : 'Crear Apikey'"
    [subtitle]="id ? apikey?.identificacion : undefined"
    [draggable]="!!dialogRef"
    [botonCerrar]="true"
    (cerrar)="volver()"
  ></app-card-header>

  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <section class="inputs-group">
          <mat-form-field style="width: 100%">
            <mat-label>Identificación</mat-label>
            <input matInput formControlName="identificacion" />
          </mat-form-field>
        </section>

        <section class="inputs-group">
          <div>
            <mat-checkbox color="primary" formControlName="global">
              Global
            </mat-checkbox>
            <small class="ayuda">
              Una apikey global accede a los datos de todos los clientes.
            </small>
          </div>
        </section>

        @if (form.get('global')?.value === false) {
          <section class="inputs-group">
            <div style="width: 100%">
              <app-cliente-selector
                formControlName="idClientes"
                [multiple]="true"
              ></app-cliente-selector>
              @if (form.hasError('forbiddenIdClientes')) {
                <small class="ayuda error">
                  Si la apikey no es global debe tener al menos un cliente.
                </small>
              }
            </div>
          </section>
        }
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="volver()">
          Cancelar
        </button>
        <button irxBoton="principal" type="submit" [disabled]="!form.valid">
          <mat-icon>save</mat-icon>
          {{ id ? 'Guardar' : 'Crear' }}
        </button>
      </mat-card-actions>
    </form>
  } @else {
    <mat-card-content class="card-content-crear">
      <section class="inputs-group">
        <app-loading text="Cargando..." [diameter]="40"></app-loading>
      </section>
    </mat-card-content>
  }
</mat-card>
